import colorPalletteImage from "../../../images/color-pallettes.jpg";

const ColorPallette = () => {
  return (
    <nav className="w-full place-items-center object-contain h-10 px-10 pt-1 rounded-t-lg bg-white ">
      <div className="grid grid-flow-col items-stretch ">
        <div className="text-base text-center pr-2 ">High</div>
        <div className=" flex justify-center ">
          <img className="max-h-8 max-w-4xl" src={colorPalletteImage} />
        </div>
        <div className="text-base text-center pl-2">Low</div>
      </div>
    </nav>
  );
};
export default ColorPallette;
